import { render, staticRenderFns } from "./ecellentCase.vue?vue&type=template&id=24f51cba&scoped=true&"
import script from "./ecellentCase.vue?vue&type=script&lang=js&"
export * from "./ecellentCase.vue?vue&type=script&lang=js&"
import style0 from "./ecellentCase.vue?vue&type=style&index=0&id=24f51cba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f51cba",
  null
  
)

export default component.exports